import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22glyphicon-font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./glyphicons/glyphicons-halflings-regular.ttf%22,%22variable%22:%22--font-glyphicons-halflings-regular%22}],%22variableName%22:%22glyphiconFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'glyphiconFont', 'glyphiconFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
